import { domPropsSelector } from './ResponsiveTable';
import { RowStatesRenderer } from './renderers/RowStatesRenderer';
import { useResponsiveTableContext } from './ResponsiveTableContext';
import { useDomProps } from './store/selection/useDomProps';
import { TResponsiveTableRowState } from './types';
import { Box } from '@apia/theme';

interface IStateCell {
  index: number;
  isHeader?: boolean;
  rowIndex: number;
  state?: TResponsiveTableRowState;
}

export const StateCell = ({ index, rowIndex, state, isHeader }: IStateCell) => {
  const { name } = useResponsiveTableContext();
  const domProps = useDomProps(
    isHeader ? 'headerStateCell' : 'stateCell',
    { columnIndex: index, rowIndex },
    domPropsSelector(name),
  );
  return (
    <Box as="td" className="stateCell" {...domProps}>
      {state?.Icon ? <RowStatesRenderer state={state} /> : ''}
    </Box>
  );
};
